import { Button, Link } from '@carvana/helios-navigation';
import { breakpoint } from '@carvana/helios-styles';
import Image from 'next/image';

import { useTestFunc } from '@carvana/test-attributes';
import { APP_BASE_PATH } from '../../shared/appBasePath';
import useAnalyticEvent from '../../shared/hooks/useAnalyticEvent';
import { useMediaQuery } from '../../shared/hooks/useMediaQuery';
import {
  ButtonContainer,
  ButtonWrapper,
  ContentWrapper,
  HeaderWrapper,
  ImageStyle,
  ImageWrapper,
  TextContainer,
  TextWrapper,
  TradeInWrapper
} from './TradeIn.styles';

const HeliosTradeIn = () => {
  const { recordActionClicked, recordEventAndNavigate } = useAnalyticEvent();
  const getTestAttributes = useTestFunc();

  const isMobile = useMediaQuery(`(max-width: ${breakpoint.sm})`);
  const learnMore = (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) =>
    recordEventAndNavigate(event, 'Landing Page', 'Trade-in, Learn More');

  const getStarted = () => {
    recordActionClicked('Landing Page', 'Trade-in, Get Started');
  };

  const imageLoader = ({ src }: { src: string }) => {
    const appUrl = process.env.CARVANA_APP_PUBLIC_URL!;
    const prefix = appUrl.includes('localhost') ? appUrl : `${appUrl}/next`;
    return `${prefix}${src}.webp`;
  };

  const wizardRoute = `${APP_BASE_PATH}/getoffer/vehicle`;

  return (
    <TradeInWrapper>
      <ContentWrapper>
        <TextContainer>
          <HeaderWrapper>Trade In and Save on Your Purchase</HeaderWrapper>
          <TextWrapper>
            Save more when you trade in the car you have for the car you want. It’s easy and all
            online.
          </TextWrapper>
          <ButtonContainer>
            <ButtonWrapper>
              <Link href={wizardRoute}>
                <Button
                  as="div"
                  size={isMobile ? 'lg' : 'sm'}
                  variant="secondaryInverted"
                  onClick={getStarted}
                  {...getTestAttributes('GetStarted', 'TradeIn-GetStarted')}
                >
                  Get&nbsp;Started
                </Button>
              </Link>
            </ButtonWrapper>
            <Link
              className={isMobile ? 'lg' : 'sm'}
              style={{ color: 'white' }}
              href="/selling-or-trades-how-it-works"
              onClick={learnMore}
              {...getTestAttributes('LearnMore', 'TradeIn-LearnMore')}
            >
              Learn&nbsp;More
            </Link>
          </ButtonContainer>
        </TextContainer>
        <ImageWrapper>
          <Image
            src="/images/HappyFamily"
            loader={imageLoader}
            alt="Get Your Offer"
            style={ImageStyle}
            fill
            sizes={`(max-width: ${breakpoint.md}) 100vw,
              (max-width: ${breakpoint.sm}) 50vw,
              33vw`}
          />
        </ImageWrapper>
      </ContentWrapper>
    </TradeInWrapper>
  );
};

export default HeliosTradeIn;
